import React, { useState } from 'react';
import { Link } from 'react-router-dom';
//import { Link, useNavigate } from 'react-router-dom';
import { doPasswordReset } from '../../../firebase/auth'; 
import './resetpassword.css'; // Create this CSS file

const ResetPassword = () => {
    //const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [isSending, setIsSending] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');

    const onSubmit = async (e) => {
        e.preventDefault();
        if (!isSending) {
            setIsSending(true);
            setErrorMessage('');
            setSuccessMessage('');
            try {
                await doPasswordReset(email);
                setSuccessMessage('Password reset email sent!');
            } catch (error) {
                setErrorMessage(error.message);
            } finally {
                setIsSending(false);
            }
        }
    };

    return (
        <div className="login-page">
            <main className="main-content">
                <div className="login-box">
                    <div className="text-center">
                        <div className="welcome-message">
                            <h3>Reset Password</h3>
                        </div>
                    </div>
                    <form onSubmit={onSubmit} className="login-form">
                        <div className="form-group">
                            <label className="form-label">Email</label>
                            <input
                                type="email"
                                autoComplete="email"
                                required
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className="form-input"
                            />
                        </div>
                        {errorMessage && <span className="error-message">{errorMessage}</span>}
                        {successMessage && <span className="success-message">{successMessage}</span>}
                        <button type="submit" disabled={isSending} className="submit-button">
                            {isSending ? 'Sending...' : 'Send Reset Email'}
                        </button>
                    </form>
                    <p className="signup-link">
                        <Link to={'/login'}>Back to Login</Link>
                    </p>
                </div>
            </main>
        </div>
    );
};

export default ResetPassword;